import React, { useState, useEffect } from "react";
import styles from "../styles/learnMoreChunk.module.css";
import cancel from "../assets/images/cancel.png";

const LearnMoreChunk = ({
  infoChunk,
  index,
  onChangeHeader,
  onChangeBody,
  onRemoveLearnMoreChunk,
}) => {
  const [headerState, setHeaderState] = useState(infoChunk.header);
  const [bodyState, setBodyState] = useState(infoChunk.body);

  const [learnMoreChunkRemoved, setLearnMoreChunkRemoved] = useState(false);
  useEffect(() => {
    setHeaderState(infoChunk.header);
    setBodyState(infoChunk.body);
  }, [learnMoreChunkRemoved, infoChunk]);

// TODO can change these interactions to useRef eventually, to eliminate unnecessary rerenders
  const onChangeHeaderText = (e) => {
    const enteredHeaderText = e.target.value;
    setHeaderState(enteredHeaderText);
    onChangeHeader(index, enteredHeaderText);
  };

  const onChangeBodyText = (e) => {
    const enteredBodyText = e.target.value;
    setBodyState(enteredBodyText);
    onChangeBody(index, enteredBodyText);
  };

  const removeLearnMoreChunk = () => {
    setLearnMoreChunkRemoved(true);
    onRemoveLearnMoreChunk(index);
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.cancelContainer}>
        <div
          className={styles.cancelIconContainer}
          onClick={removeLearnMoreChunk}
        >
          <img src={cancel} alt="Cancel Icon" className={styles.cancelIcon} />
        </div>
      </div>
      <div className={styles.inputContainer}>
        <p className={styles.label}>Header:</p>
        <input
          className={styles.inputStyle}
          value={headerState}
          placeholder="Optional title or code for text below..."
          onChange={onChangeHeaderText}
          required
        />
      </div>
      <div className={styles.inputContainer}>
        <p className={styles.label}>Body:</p>
        <textarea
          className={styles.inputStyleArea}
          value={bodyState}
          placeholder="Please enter informational text here (required)..."
          onChange={onChangeBodyText}
          required
        />
      </div>
    </div>
  )
};

export default LearnMoreChunk;
